// extracted by mini-css-extract-plugin
module.exports = {"root":"BodyFilter_root__3Mffb","contentForm":"BodyFilter_contentForm__3xfvc"};